import { Injectable, signal, computed, effect } from '@angular/core';

export type ViewMode = 'grid' | 'list';

@Injectable({
  providedIn: 'root'
})
export class ViewModeService {
  // Estado reativo principal
  private _viewMode = signal<ViewMode>('grid');
  
  // Estado para saber se é mobile
  private _isMobile = signal<boolean>(false);

  // Expor sinal de leitura pública
  public readonly viewMode = this._viewMode.asReadonly();
  public readonly isMobile = this._isMobile.asReadonly();

  constructor() {
    this.init();
  }

  private init(): void {
    if (typeof window !== 'undefined') {
      // 1. Verificar tamanho inicial da tela
      this.checkScreenSize();

      // 2. Ouvir mudanças de tamanho de tela
      window.addEventListener('resize', () => this.checkScreenSize());

      // 3. Carregar preferência salva (apenas se não for mobile)
      if (!this._isMobile()) {
        const saved = localStorage.getItem('viewMode') as ViewMode;
        if (saved) {
          this._viewMode.set(saved);
        }
      }
    }
  }

  private checkScreenSize(): void {
    const isSmall = window.matchMedia('(max-width: 768px)').matches;
    this._isMobile.set(isSmall);

    if (isSmall) {
      // Se for mobile, FORÇA o grid
      this._viewMode.set('grid');
    }
  }

  public setMode(mode: ViewMode): void {
    // Se for mobile, ignora tentativas de mudar para list
    if (this._isMobile() && mode === 'list') {
      return;
    }

    this._viewMode.set(mode);
    
    // Salva no localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('viewMode', mode);
    }
  }
}